import { products } from '../data/products.js';

const ORDER_STORAGE_KEY = 'ata-code-house-orders';
const CART_API_STORAGE_KEY = 'ata-code-house-cart-api';

function delay() {
  return new Promise((resolve) =>
    window.setTimeout(resolve, 140 + Math.floor(Math.random() * 180))
  );
}

function readOrders() {
  const saved = localStorage.getItem(ORDER_STORAGE_KEY);
  return saved ? JSON.parse(saved) : [];
}

function writeOrders(data) {
  localStorage.setItem(ORDER_STORAGE_KEY, JSON.stringify(data));
}

function readCartApi() {
  const saved = localStorage.getItem(CART_API_STORAGE_KEY);
  return saved ? JSON.parse(saved) : [];
}

function writeCartApi(data) {
  localStorage.setItem(CART_API_STORAGE_KEY, JSON.stringify(data));
}

export async function fetchProducts() {
  await delay();
  return products;
}

export async function postCartItem(product) {
  await delay();
  const cart = readCartApi();
  const existing = cart.find((item) => item.id === product.id);

  if (existing) {
    existing.quantity += 1;
  } else {
    cart.push({ ...product, quantity: 1 });
  }

  writeCartApi(cart);
  return {
    status: 'ok',
    message: 'Product added to cart.',
    cart,
  };
}

export async function createOrder(payload) {
  await delay();
  const orders = readOrders();
  const order = {
    id: `ORD-${Date.now()}`,
    createdAt: new Date().toISOString(),
    status: 'confirmed',
    estimatedDelivery: '2-4 business days',
    customer: payload.customer,
    items: payload.items,
    total: payload.total,
  };

  orders.unshift(order);
  writeOrders(orders);
  writeCartApi([]);

  return order;
}

export async function fetchOrders() {
  await delay();
  return readOrders();
}

export async function fetchApiStatus() {
  await delay();
  const orders = readOrders();
  const cart = readCartApi();

  return {
    status: 'online',
    service: 'ATA Code House Demo Service',
    productCount: products.length,
    orderCount: orders.length,
    cartCount: cart.reduce((sum, item) => sum + item.quantity, 0),
    timestamp: new Date().toISOString(),
  };
}
